// extracted by mini-css-extract-plugin
export default {"external":"azjj3M","assetsCarousel":"bzjj3M","cardMargin":"czjj3M"};